import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import type { ButtonProps } from 'Components/frameworks/button/Button';
import { Button } from 'Components/frameworks/button/Button';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Text } from 'Components/frameworks/text/Text';
import { TextLink } from 'Components/frameworks/text-link/TextLink';
export type Props = {
  button?: ButtonProps | null | undefined;
  className?: string;
  icon?: IconName;
  link?: {
    label?: string;
    url?: string;
  };
  status?: 'success' | 'error' | 'neutral';
  text?: string;
  title?: string;
};

const getDefaultIcon = (status) => (status === 'success' ? ICONS.CHECK_OUTLINE : ICONS.WARNING);

export const Confirmation = ({
  button = {},
  className,
  icon,
  link,
  status,
  text,
  title,
}: Props) => {
  if (!status || !title) {
    return null;
  }

  const colors = {
    error: COLORS.RED,
    neutral: COLORS.BLACK,
    success: COLORS.GREEN,
  };
  const iconName = icon ? icon : getDefaultIcon(status);
  return (
    <div
      className={classnames(
        'flex items-start gap-20 text-12 sm:items-center sm:text-20',
        `text-${colors[status]}`,
        className,
      )}
    >
      <Icon className="shrink-0" name={iconName} width="4em" />
      <div className="flex-auto">
        <p className={classnames('text-16 font-bold sm:text-20', `text-${colors[status]}`)}>
          {title}
        </p>
        <Text text={text} />
        <p>
          <TextLink {...link} className="mt-10 underline" />
        </p>
        {button && button.children && (
          <Button {...button} className="mt-10">
            {button.children}
          </Button>
        )}
      </div>
    </div>
  );
};
